import { useState, useEffect, useCallback } from 'react';
import { Moon, Sun } from 'lucide-react';
import '../styles/platform-theme.css';
import '../styles/platform-finesse.css';

const STORAGE_KEY = 'altrunic-platform-theme';

/* Wraps the customer-facing platform screens so the shared theme layer
   applies. Dark by default; the choice persists per browser. */
export const PlatformShell = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark';
    } catch {
      return 'dark';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* private browsing - the theme just won't persist */
    }
  }, [theme]);

  // body sits outside .alt-app, so without this it stays white and shows
  // through on overscroll and on pages shorter than the viewport
  useEffect(() => {
    const previous = document.body.style.backgroundColor;
    document.body.style.backgroundColor = theme === 'dark' ? '#07090E' : '#F8FAFC';
    return () => {
      document.body.style.backgroundColor = previous;
    };
  }, [theme]);

  const toggle = useCallback(
    () => setTheme((t) => (t === 'dark' ? 'light' : 'dark')),
    []
  );

  return (
    <div className="alt-app" data-theme={theme} data-testid="platform-shell">
      {children}
      <button
        type="button"
        onClick={toggle}
        className="alt-theme-toggle"
        data-testid="theme-toggle"
        aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      >
        {theme === 'dark' ? <Sun size={14} /> : <Moon size={14} />}
        {theme === 'dark' ? 'Light mode' : 'Dark mode'}
      </button>
    </div>
  );
};

export default PlatformShell;
